import React from "react";
import styled from "styled-components";
import Container from "src/react/layout/container";
import { LinkButton } from "src/react/components/link";
import { color } from "src/styles/variables";

const heroImage = `https://images.ctfassets.net/itvcls9imtx8/478kVF7mZKymvZJxkrLgGw/a3d87ed2e0f9387fba9395854254c217/homepage-hero.jpg`;

function Hero({ showHeroText = true, image = heroImage }) {
  return (
    <Wrapper showHeroText={showHeroText} image={image}>
      {showHeroText && (
        <Container>
          <Inner>
            <Title>The Cornerstone of a great day</Title>
            <Subtitle>
              Quality men's shaving, bathroom and healthcare supplies,
              delivered.
            </Subtitle>
            <LinkButton
              align="center"
              tracking="custom"
              trackingOptions={{
                location: "homepage",
              }}
              data-selector="products-button"
              variant="primary"
              to="/products"
            >
              Shop now
            </LinkButton>
          </Inner>
        </Container>
      )}
    </Wrapper>
  );
}

export default Hero;

const breakPoint = "@media (min-width: 768px)";
const smallBreakPoint = "@media (min-width: 460px)";

const Wrapper = styled.div`
  background-position: center;
  background-size: cover;
  height: 270px;
  padding-top: 40px;
  position: relative;
  background-image: url(${({ image }) => image}?w=920);
  ${({ showHeroText }) =>
    showHeroText &&
    `:after {
    content: "";
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.1)
    );
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }`}
  ${smallBreakPoint} {
    height: 350px;
    background-image: url(${({ image }) => image}?w=1534);
  }
  ${breakPoint} {
    height: 450px;
    padding-top: 60px;
    background-image: url(${({ image }) => image});
  }
`;

const Inner = styled.div`
  color: ${color.white};
  position: relative;
  z-index: 10;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 15px;
  ${smallBreakPoint} {
    font-size: 44px;
  }
`;

const Subtitle = styled.h2`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 20px;
  ${smallBreakPoint} {
    font-size: 20px;
  }
`;
